import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { useAsyncEffect } from 'customHooks/hooks';
import React, { ReactElement, useContext } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { fetchQuestionnaireData } from 'screens/WidgetGenerator/helpers/fetchQuestionnaireData';
import { ReportBuilderWidgetProps } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import { QUESTIONNAITE_DEFAULT_SPLIT_POSITION } from 'screens/WidgetGenerator/reportGeneratorComponents/constants';
import { QuestionnaireWidgetData } from 'screens/WidgetGenerator/utils/misc';
import { Questionnaire } from 'screens/WidgetGenerator/widgets/Questionnaire/Questionnaire';
import { useTranslation } from 'react-i18next';
import { logger } from 'utils/logger';

const DEFAULT_QUESTIONNAIRE_WIDGET_DATA: QuestionnaireWidgetData[] = [
  {
    questions: [],
    aspect: {
      id: -1,
      value: 'Invalid',
      label: 'Invalid Aspect',
    },
  },
];

export const QuestionnaireHOC = (props: ReportBuilderWidgetProps): ReactElement => {
  const { t: translate } = useTranslation();
  const { client, selectedSurveyGroup } = useContext(WidgetGeneratorContext);
  const { params } = props;
  const { filters } = params;

  const selectedSurveyOption = filters?.questionnaireSurveySingleSelect;
  const selectedAspectOptions = filters?.questionnaireAspectsSelect;
  const selectedSplitPosition = filters?.questionnaireTableSplitPosition ?? QUESTIONNAITE_DEFAULT_SPLIT_POSITION;
  const selectedTableIndexToDisplay = filters?.questionnaireTableToDisplay;
  const selectedSurveyId = selectedSurveyOption?.value as number;

  const getQuestionnaireData = async (): Promise<QuestionnaireWidgetData[]> => {
    if (selectedSurveyOption && selectedAspectOptions && selectedAspectOptions.length) {
      const aspectIds = selectedAspectOptions.map((aspect) => {
        const aspectId = aspect.value as number;
        return aspectId;
      });
      const fetchedQuestionnaireData = await fetchQuestionnaireData({
        client,
        surveyId: selectedSurveyId,
        aspectIds: aspectIds ?? [],
      });
      return fetchedQuestionnaireData;
    }
    return DEFAULT_QUESTIONNAIRE_WIDGET_DATA;
  };

  const {
    fetchedData: questionnaireData,
    isLoading,
    error,
  } = useAsyncEffect(getQuestionnaireData, [client, selectedSurveyGroup, selectedSurveyOption, selectedAspectOptions]);

  if (error) {
    logger.error(error);
  }
  return (
    <LoaderMask isLoading={isLoading}>
      {!selectedSurveyOption && <h3>{translate('widgetGenerator.widgets.questionnaire.selectSurveyHOCHelper')}</h3>}
      {!selectedAspectOptions?.length && (
        <h3>{translate('widgetGenerator.widgets.questionnaire.selectAspectsHOCHelper')}</h3>
      )}
      <Questionnaire
        widgetData={questionnaireData ?? DEFAULT_QUESTIONNAIRE_WIDGET_DATA}
        splitPositionQuestionnaire={selectedSplitPosition}
        showAspectTableTitle={false}
        tableIndexToDisplay={selectedTableIndexToDisplay}
      />
    </LoaderMask>
  );
};
